// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"f84134dd","160":"68b28295","208":"61426e53","293":"74cdc352","488":"1487971a","516":"d709ec1f","519":"a7df6815","917":"4ebd0afb","946":"4a6888b9"}[chunkId] + ".chunk.js";
};